import type { MessageListResponse } from '@tandemone/types'
import { useInfiniteQuery } from '@tanstack/react-query'

import { listMessages } from './api'
import { conversationMessagesKey } from './keys'

const PAGE_SIZE = 50

/** messages are returned newest-first by the api and paginated by a
 * createdAt cursor. infinite query gives the message thread "load older"
 * scrolling without bespoke pagination state.
 */
export function useMessages(conversationId: string | null) {
  return useInfiniteQuery<MessageListResponse>({
    queryKey: conversationMessagesKey(conversationId ?? ''),
    enabled: !!conversationId,
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam, signal }) =>
      listMessages(
        conversationId!,
        {
          before: pageParam as string | undefined,
          limit: PAGE_SIZE
        },
        signal
      ),
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    staleTime: 30_000
  })
}
